// import React from 'react';
import Cookies from 'universal-cookie';
import moment from 'moment';
import * as rssParser from 'react-native-rss-parser';

import {
  saveAs
} from 'file-saver'

const cookies = new Cookies();
const __TxtElement = document.createElement("textarea");

const circularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null && key !== null &&  ! (""+key).startsWith("_")) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};


const dummy = function(...arr) {
  for(var i=0;i<arr.length;i++) {
    if( typeof arr[i] === 'object') {
      try {
       arr[i] =  JSON.stringify(arr[i],circularReplacer());
     } catch {
     }
    }
  }
  _GPY.log.push(new Date().toString() + " -*- " + arr.join(" -*- "));
  if(_GPY.log.length > 350) {
    _GPY.log = _GPY.log.slice(-300);
  }
};

if(process.env.REACT_APP_DEBUGOUT!=="true"){
  console.log = dummy;
  console.warn = dummy;
  console.error = dummy;
}

const _GPY = {
  log:[],
  _InitIntervall: undefined,
  standaloneMode: process.env.REACT_APP_standaloneMode === "true",
  baseUrl: process.env.REACT_APP_baseUrl,
  webSocket: process.env.REACT_APP_webSocket,
  displayUrl: process.env.REACT_APP_displayUrl,
  resourceUrl: process.env.REACT_APP_resourceUrl,

  cloneObj: function (src) {
    return JSON.parse(JSON.stringify(src));
  },
  secondsToTime: function (s) {
    var minF = s / 60;
    var minI = Math.floor(minF);
    var sec = Math.floor((minF - minI) * 60);
    var formatSec = ('00' + sec).slice(-2);
    return minI + ":" + formatSec;
  },
  decodeHtml:function (html) {
      __TxtElement.innerHTML = html;
      return __TxtElement.value;
  },
  removeTags:function(str){
   if ((str===null) || (str==='')) {
       return "";
   } else {
     return (""+str).replace(/<[^>]*>/g, '');
  }
 },
  playerSorter: function (a, b) {
    if (a._config === undefined || b._config === undefined) {
      return ("" + a.lastName).localeCompare(b.lastName);
    };

    if (a._config.player !== undefined && b._config.player !== undefined) {
      if (a._config.player && !b._config.player) {
        return 0;
      } else if (!a._config.player && b._config.player) {
        return 1;
      }
    }

    if (a._config.substitue !== undefined && b._config.substitue !== undefined) {
      if (a._config.substitue && !b._config.substitue) {
        return 0;
      } else if (!a._config.substitue && b._config.substitue) {
        return 1;
      }
    }

    if (a._config.sortIndex !== undefined && b._config.sortIndex !== undefined && a._config.sortIndex !== b._config.sortIndex) {
      return a._config.sortIndex - b._config.sortIndex;
    }
    return ("" + a.lastName).localeCompare(b.lastName);

  },
  userFonts: [],
  loadFonts: function (callBack) {
    __GPYGet('getFonts', (res) => {
      if (res.Result.resultDataAsList !== undefined) {
        this.setUpFontStyles("GPYUserFonts", res.Result.resultDataAsList);
        if (callBack !== undefined) callBack();
      }
    }, (res) => {
      this.setUpFontStyles("GPYUserFonts", []);
      if (callBack !== undefined) callBack();
    });
  },
  fontUrlToName: function (f) {
    return f.substring(f.lastIndexOf('/') + 1, f.lastIndexOf('.'));
  },
  setUpFontStyles: function (styleName, fonts) {
    this.userFonts = fonts;
    var css = "";
    fonts.forEach((f, i) => {
      css += "@font-face { font-family: '" + this.fontUrlToName(f) + "'; src:url('" + this.resource("upload/" + f) + "') format('truetype'); }";
    });

    var styleElement = document.getElementById(styleName);
    if (styleElement) document.getElementsByTagName('head')[0].removeChild(styleElement);

    styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.id = styleName;
    styleElement.innerHTML = css;

    document.getElementsByTagName('head')[0].appendChild(styleElement);
  },

  weatherIcons: {
    "200": {
      "label": "thunderstorm with light rain",
      "icon": "storm-showers"
    },

    "201": {
      "label": "thunderstorm with rain",
      "icon": "storm-showers"
    },

    "202": {
      "label": "thunderstorm with heavy rain",
      "icon": "storm-showers"
    },

    "210": {
      "label": "light thunderstorm",
      "icon": "storm-showers"
    },

    "211": {
      "label": "thunderstorm",
      "icon": "thunderstorm"
    },

    "212": {
      "label": "heavy thunderstorm",
      "icon": "thunderstorm"
    },

    "221": {
      "label": "ragged thunderstorm",
      "icon": "thunderstorm"
    },

    "230": {
      "label": "thunderstorm with light drizzle",
      "icon": "storm-showers"
    },

    "231": {
      "label": "thunderstorm with drizzle",
      "icon": "storm-showers"
    },

    "232": {
      "label": "thunderstorm with heavy drizzle",
      "icon": "storm-showers"
    },

    "300": {
      "label": "light intensity drizzle",
      "icon": "sprinkle"
    },

    "301": {
      "label": "drizzle",
      "icon": "sprinkle"
    },

    "302": {
      "label": "heavy intensity drizzle",
      "icon": "sprinkle"
    },

    "310": {
      "label": "light intensity drizzle rain",
      "icon": "sprinkle"
    },

    "311": {
      "label": "drizzle rain",
      "icon": "sprinkle"
    },

    "312": {
      "label": "heavy intensity drizzle rain",
      "icon": "sprinkle"
    },

    "313": {
      "label": "shower rain and drizzle",
      "icon": "sprinkle"
    },

    "314": {
      "label": "heavy shower rain and drizzle",
      "icon": "sprinkle"
    },

    "321": {
      "label": "shower drizzle",
      "icon": "sprinkle"
    },

    "500": {
      "label": "light rain",
      "icon": "rain"
    },

    "501": {
      "label": "moderate rain",
      "icon": "rain"
    },

    "502": {
      "label": "heavy intensity rain",
      "icon": "rain"
    },

    "503": {
      "label": "very heavy rain",
      "icon": "rain"
    },

    "504": {
      "label": "extreme rain",
      "icon": "rain"
    },

    "511": {
      "label": "freezing rain",
      "icon": "rain-mix"
    },

    "520": {
      "label": "light intensity shower rain",
      "icon": "showers"
    },

    "521": {
      "label": "shower rain",
      "icon": "showers"
    },

    "522": {
      "label": "heavy intensity shower rain",
      "icon": "showers"
    },

    "531": {
      "label": "ragged shower rain",
      "icon": "showers"
    },

    "600": {
      "label": "light snow",
      "icon": "snow"
    },

    "601": {
      "label": "snow",
      "icon": "snow"
    },

    "602": {
      "label": "heavy snow",
      "icon": "snow"
    },

    "611": {
      "label": "sleet",
      "icon": "sleet"
    },

    "612": {
      "label": "shower sleet",
      "icon": "sleet"
    },

    "615": {
      "label": "light rain and snow",
      "icon": "rain-mix"
    },

    "616": {
      "label": "rain and snow",
      "icon": "rain-mix"
    },

    "620": {
      "label": "light shower snow",
      "icon": "rain-mix"
    },

    "621": {
      "label": "shower snow",
      "icon": "rain-mix"
    },

    "622": {
      "label": "heavy shower snow",
      "icon": "rain-mix"
    },

    "701": {
      "label": "mist",
      "icon": "sprinkle"
    },

    "711": {
      "label": "smoke",
      "icon": "smoke"
    },

    "721": {
      "label": "haze",
      "icon": "day-haze"
    },

    "731": {
      "label": "sand, dust whirls",
      "icon": "cloudy-gusts"
    },

    "741": {
      "label": "fog",
      "icon": "fog"
    },

    "751": {
      "label": "sand",
      "icon": "cloudy-gusts"
    },

    "761": {
      "label": "dust",
      "icon": "dust"
    },

    "762": {
      "label": "volcanic ash",
      "icon": "smog"
    },

    "771": {
      "label": "squalls",
      "icon": "day-windy"
    },

    "781": {
      "label": "tornado",
      "icon": "tornado"
    },

    "800": {
      "label": "clear sky",
      "icon": "sunny"
    },

    "801": {
      "label": "few clouds",
      "icon": "cloudy"
    },

    "802": {
      "label": "scattered clouds",
      "icon": "cloudy"
    },

    "803": {
      "label": "broken clouds",
      "icon": "cloudy"
    },

    "804": {
      "label": "overcast clouds",
      "icon": "cloudy"
    },


    "900": {
      "label": "tornado",
      "icon": "tornado"
    },

    "901": {
      "label": "tropical storm",
      "icon": "hurricane"
    },

    "902": {
      "label": "hurricane",
      "icon": "hurricane"
    },

    "903": {
      "label": "cold",
      "icon": "snowflake-cold"
    },

    "904": {
      "label": "hot",
      "icon": "hot"
    },

    "905": {
      "label": "windy",
      "icon": "windy"
    },

    "906": {
      "label": "hail",
      "icon": "hail"
    },

    "951": {
      "label": "calm",
      "icon": "sunny"
    },

    "952": {
      "label": "light breeze",
      "icon": "cloudy-gusts"
    },

    "953": {
      "label": "gentle breeze",
      "icon": "cloudy-gusts"
    },

    "954": {
      "label": "moderate breeze",
      "icon": "cloudy-gusts"
    },

    "955": {
      "label": "fresh breeze",
      "icon": "cloudy-gusts"
    },

    "956": {
      "label": "strong breeze",
      "icon": "cloudy-gusts"
    },

    "957": {
      "label": "high wind, near gale",
      "icon": "cloudy-gusts"
    },

    "958": {
      "label": "gale",
      "icon": "cloudy-gusts"
    },

    "959": {
      "label": "severe gale",
      "icon": "cloudy-gusts"
    },

    "960": {
      "label": "storm",
      "icon": "thunderstorm"
    },

    "961": {
      "label": "violent storm",
      "icon": "thunderstorm"
    },

    "962": {
      "label": "hurricane",
      "icon": "cloudy-gusts"
    }
  },

  toNumber: function (str) {
    if (isNaN(parseInt(str))) {
      return "";
    } else {
      return parseInt(str);
    }
  },
  toPlayerName: function (player) {
    if (player === undefined) return "";
    var pre = player.numOrPos !== undefined && player.numOrPos !== "" ? player.numOrPos + " " : "";
    return pre + (player.firstName !== undefined ? player.firstName + " " : "") + (player.lastName !== undefined ? player.lastName : "");
  },


  replacer: function (name, val) {
    if (name.startsWith("__")) {
      return undefined; // remove from result
    } else {
      return val; // return as is
    }
  },
  resource: function (url) {
    return this.resourceUrl + "resources/" + url;
  },
  USER_EXPERT: 300,
  USER_TRANSLATOR: 250,
  USER_PRO: 200,
  USER_REGISTER: 100,


  empty: function (value, def) {
    if (value === undefined || value === '') {
      return def === undefined ? "" : def;
    }
    return value;
  },
  language: (navigator.language || navigator.userLanguage || "en-UK").split("-")[0],
  uiStates: {},
  displayMode: false,
  did: '',
  acc: undefined,
  sessionId: undefined,
  session: "",
  initComplete: false,
  setLanguage: function (locale) {
    __GPYPost("changeLanguage", {
      locale: locale
    }, (result) => {
      window.location.reload(false);
    });
  },
  i18n: {
    unknownKeys: [],
    values:{},
    get: function (key, def) {
      // console.log("I18GET",key,this[key]);
      if (this.values[key] !== undefined) {
        return (this.values[key]);
      } else {
        if(!this.unknownKeys.includes(key)){
          this.unknownKeys.push(key);
        }
        if (def !== undefined) {
          return (def);
        } else {
          return (key);
        }
      }
    },

  },
  null2Empty: function(c) {
		return c===null||c===undefined?"":c;
	},
  toLocaleMoment: function (milis) {
    return moment(milis);
  },

  isValidEmail: function (value) {
    var x = /\S+@\S+\.\S+/;
    return x.test(value);
  },
  isValidPassword: function (value) {
    var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&]){8,}/;
    return re.test(value);
  },
  isEmpty: function (value) {
    return (value !== undefined && value !== '')
  },
  isMin3: function (value) {
    return (value !== undefined && value !== '' && value.length > 2)
  },
  isMin2: function (value) {
    return (value !== undefined && value !== '' && value.length > 1)
  },
  isMin1: function (value) {
    return (value !== undefined && value !== '')
  },
  emptyIsValid: function (value) {
    return true;
  },
  getDisplayKeyCode : function (c) {
    if(c!==undefined && c.keyCode!==undefined) {
      if(c.keyCode === " "){
        return " | Spacebar";
      }
      if(c.keyCode === "ArrowRight"){
        return " | →";
      }
      if(c.keyCode === "ArrowLeft"){
        return " | ←";
      }
      if(c.keyCode === "ArrowUp"){
        return " | ↑";
      }
      if(c.keyCode === "ArrowDown"){
        return " | ↓";
      }
      return " | " + c.keyCode;
    }
    return ""
  },
  null2Empty : function(s){
    if(s===undefined) return "";
    return s;
  },
  clientInfo : function () {
     return "TZ:"+ ((new Date()).getTimezoneOffset()/60) + " ["+ navigator.language+"] : "+window.location.href + " -> ("+navigator.userAgent+")";
  }

};


const __GPYSmallInit = function (onInitComplete) {
  _GPY.sessionId = cookies.get("guppyi");
  if (_GPY.sessionId !== undefined && _GPY.sessionId !== '') {
    _GPY.session = ";gpy=" + _GPY.sessionId;
  }
  _GPY.onInitComplete = onInitComplete;
  __GPYGetUIStates();
};

const __GPYInit = function (onInitComplete) {

  const params = new URLSearchParams(window.location.search);
  const did = params.get('did');
  const rp = params.get('rp');
  const acc = params.get('acc');

  const host = params.get('host');
  if (host !== undefined && host !== null && host !== '') {
    _GPY.baseUrl = 'http://' + host + '/guppyi/json/';
    _GPY.webSocket = 'ws://' + host + '/wsguppyi/';
    _GPY.displayUrl = 'http://' + host + '/?host=' + host + '&did=';
  }

  _GPY.displayMode = (did !== undefined && did !== null && did !== '');
  _GPY.did = did;
  _GPY.onInitComplete = onInitComplete;

  if (!_GPY.displayMode) {
    _GPY.sessionId = cookies.get("guppyi");

    window.$crisp = [
      ["safe", true]
    ];
    window.CRISP_WEBSITE_ID = "74606c8a-2664-44f3-a373-b8b4ae3e0926";
    var s = document.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    s.async = 1;
    document.getElementsByTagName("head")[0].appendChild(s);
  }

  if (_GPY.sessionId !== undefined && _GPY.sessionId !== '') {
    _GPY.session = ";gpy=" + _GPY.sessionId + (_GPY.displayMode ? "?did=" + did : "");
  } else {
    _GPY.session = (_GPY.displayMode ? "?did=" + did : "");
  }
  __GPYGetUIStates();

  if (acc !== undefined && (acc === 'reset' || acc === 'register') && rp !== undefined) {
    if (acc === 'register') {
      __GPYPost('confirmUser', {
        confirmId: rp
      });
    } else {
      _GPY.acc = acc;
      _GPY.confirmId = rp;
    }
  }

}

const __GPYGetI18nValues = function () {

  __GPYPost('getI18nValues', {
    locale: _GPY.locale
  }, (result) => {
    result.i18n.values.get = _GPY.i18n.get;
    _GPY.i18n.values = result.i18n.values;
    _GPY.onInitComplete();
  }, (result) => {
    console.log("getI18nValues FAIL");
  });
}

const __GPYGetUIStates = function () {

  __GPYGet("getUIState", (result) => {

      if (_GPY._InitIntervall !== undefined) {
        clearInterval(_GPY._InitIntervall);
        _GPY._InitIntervall = undefined;
      }

      if (result === undefined || result.UIState === undefined || result.UIState.values === undefined) {
        _GPY._InitIntervall = setInterval(() => __GPYGetUIStates(), (3 * 1000));
        return;
      }

      for (var k in result.UIState.values) {
        // console.log("UIState: ", k ,result.UIState.values[k].value);
        _GPY.uiStates[k] = result.UIState.values[k].value;
      }

      _GPY.sessionId = _GPY.uiStates.sessionId;
      _GPY.session = ";gpy=" + _GPY.sessionId + (_GPY.displayMode ? "?did=" + _GPY.did : "");
      cookies.set('guppyi', _GPY.sessionId, {
        path: '/'
      });

      // on LOAD USER DATA
      cookies.set('guppyi-lt', "TODO:" + _GPY.sessionId, {
        path: '/',
        maxAge: (60 * 60 * 24 * 365)
      });


      if (_GPY.displayMode && _GPY.uiStates.__display === undefined) {
        _GPY._InitIntervall = setInterval(() => __GPYGetUIStates(), (3 * 1000));
        return;
      }

      if (_GPY.displayMode && _GPY.uiStates.__display !== undefined && _GPY.uiStates.__displayGameType !== _GPY.uiStates.gameType) {
        _GPY._InitIntervall = setInterval(() => __GPYGetUIStates(), (3 * 1000));
        return;
      }

      var lang = _GPY.uiStates["userLanguage"];
      if (lang !== undefined && lang !== '') {
        _GPY.locale = lang;
      }

      __GPYGetI18nValues();

    },
    (result) => {
      if (_GPY._InitIntervall === undefined) {
        _GPY._InitIntervall = setInterval(() => __GPYGetUIStates(), (3 * 1000))
      }
    })
}


const __GPYGet = function (method, onSuccess, onFail) {
  fetch(_GPY.baseUrl + method + _GPY.session, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
    .then(res => res.json())
    .then((res) => {
      if (res.Result !== undefined && res.Result.state === 'FATAL') {
        window.location.reload(false);
      }
      if (onSuccess !== undefined) {
        onSuccess(res);
      }
    }).catch((res) => {
      if (onFail !== undefined) {
        onFail(res);
      }
    })
}

const __GPYGetRSS = function (url, onSuccess, onFail) {
  var data = {uri:url};
  fetch(_GPY.baseUrl + "getRSS" + _GPY.session, {
      method: 'POST',
      body: JSON.stringify(data !== undefined ? data : {}, _GPY.replacer),
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
    .then((response) => response.text())
    .then((responseData) => rssParser.parse(responseData))
    .then((res) => {
      if (res.Result !== undefined && res.Result.state === 'FATAL') {
        window.location.reload(false);
      }
      if (onSuccess !== undefined) {
        onSuccess(res);
      }
    }).catch((res) => {
      if (onFail !== undefined) {
        onFail(res);
      }
    })
}

const __GPYPost = function (method, data, onSuccess, onFail) {
  fetch(_GPY.baseUrl + method + _GPY.session, {
      method: 'POST',
      body: JSON.stringify(data !== undefined ? data : {}, _GPY.replacer),
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    })
    .then(res => res.json())
    .then((res) => {
      if (res.Result !== undefined && res.Result.state === 'FATAL') {
        window.location.reload(false);
      }
      if (onSuccess !== undefined) {
        onSuccess(res);
      }
    })
    .catch((res) => {
      if (onFail !== undefined) {
        onFail(res);
      }
    })
}
const __GPYPostDownload = function (method, data, onSuccess, onFail) {
  fetch(_GPY.baseUrl + method + _GPY.session, {
      method: 'POST',
      body: JSON.stringify(data !== undefined ? data : {}),
      credentials: 'include',
      responseType: 'blob', // important
      headers: {
        'Accept': 'application/pdf',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    })
    .then(response => response.blob())
    .then((blob) => {
      saveAs(blob, data.fileName);
      if (onSuccess !== undefined) {
        onSuccess(blob);
      }
    })
    .catch((res) => {
      if (onFail !== undefined) {
        onFail(res);
      }
    })
}

export {
  _GPY,
  __GPYInit,
  __GPYSmallInit,
  __GPYPost,
  __GPYPostDownload,
  __GPYGet,
  __GPYGetRSS,
  __GPYGetUIStates,
  __GPYGetI18nValues
};
